export enum DEFAULT_PRICE_VERSION {
	V1111 = 'defaultPricesV1111',
	V0 = 'defaultPricesV0',
	V1 = 'defaultPricesV1',
	V2 = 'defaultPricesV2',
	V3 = 'defaultPricesV3',
	V4 = 'defaultPricesV4',
	V5 = 'defaultPricesV5',
}
